import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { cn } from '../../lib/utils'

const statusClasses = {
  none: 'bg-background',
  correct: 'border-[#8fc98f] bg-[#addbad]',
  wrong: 'border-[#eb9d8d] bg-[#f7b9ac]',
  misplaced: 'border-[#ddd55f] bg-[#f1ea82]',
  invalid: 'border-orange-500 bg-orange-400',
}

export class Char extends Component {
  render() {
    const { char, status } = this.props;
    return (
        <div
            className={cn(
                'flex aspect-square w-full items-center justify-center rounded-md border-2 border-border text-3xl font-bold uppercase leading-none text-[#262626] sm:text-4xl',
                statusClasses[status] ?? statusClasses.none
            )}
        >
          { char }
        </div>
    );
  }
}

Char.propTypes = {
  char: PropTypes.string,
  status: PropTypes.string
};
